import { Amplitude } from '@amplitude/react-amplitude';
import classnames from 'classnames';
import map from 'lodash.map';
import size from 'lodash.size';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { LogEvent } from '@/modules/core/amplitude/types/Amplitude';
import { LabeledLink } from '@/modules/core/data/types/LabeledLink';
import { GenericObject } from '@/modules/core/data/types/GenericObject';
import {
  AMPLITUDE_ACTIONS,
  AMPLITUDE_EXTERNAL_LINK_TYPES,
} from '@/modules/core/amplitude/events';
import ExternalLink from '@/components/dataDisplay/ExternalLink';
import LinkButton from '@/components/dataDisplay/LinkButton';

type Props = {
  links: LabeledLink[];
  className?: string;
}

/**
 * Displays all links of a solution.
 */
const SolutionLinks: React.FunctionComponent<Props> = (props) => {
  const {
    links, className,
  } = props;
  const { t } = useTranslation();

  return (
    <Amplitude
      eventProperties={(inheritedProps): GenericObject => ({
        ...inheritedProps,
      })}
    >
      {({ logEvent }: { logEvent: LogEvent }): JSX.Element => (
        <div className={classnames(className)}>
          {
            size(links) ? (
              <Fragment>
                {
                  map(links, (link: LabeledLink, i: number) => {
                    const key = i;
                    const url = link?.url;
                    const label = link?.label;

                    return (
                      <ExternalLink
                        key={key}
                        href={url}
                        onClick={(): void => {
                          logEvent('solutions-externalLink-opened', {
                            selection: {
                              url: url,
                              type: AMPLITUDE_EXTERNAL_LINK_TYPES.WEBSITE,
                            },
                            action: AMPLITUDE_ACTIONS.CLICK,
                          });
                        }}
                      >
                        <LinkButton>
                          {label || t('solutionsPage.solutionCard.additionalLink.fallbackLink', 'Lien')}
                        </LinkButton>
                      </ExternalLink>
                    );
                  })
                }
              </Fragment>
            ) : null
          }
        </div>
      )}
    </Amplitude>
  );
};

export default SolutionLinks;

